export default "__VITE_ASSET__BiFgU7CP__"